import CloseButton from '../../../action/button/close.gjs';
import FlexRow from '../../../layout/flex/row.gjs';
import styles from './container.module.scss';

<template>
  <FlexRow
    @alignItems="center"
    @alignSelf="stretch"
    @justifyContent="center"
    class="{{styles.component}} spds-modal-announcement-media-container"
    data-test-spds-modal-announcement-media-container
  >
    <CloseButton
      @absolute={{true}}
      @close={{@close}}
      class="spds-modal-announcement-media-close-button"
      data-test-spds-modal-announcement-close-button
    />
    {{yield}}
  </FlexRow>
</template>
